import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import "react-phone-input-2/lib/style.css";
import PropTypes from "prop-types";
import { Row, Col, Form, Select, Input, Spin } from "antd";
import { PercentageOutlined, SaveOutlined } from "@ant-design/icons";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { ReactComponent as User } from "../../image/User.svg";
import { authUserData } from "../../utils/Helper";
import { getRequest, patchRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import PaymentBankFields from "./PaymentBankFields";
import PaymentLCFields from "./PaymentLCFields";

const PaymentVendor = ({
  paymenttermsId,
  VendorId,
  setPaymentTermsId,
  gstVendorId,
  setShowPaymentPersonReleasedField,
}) => {
  const { t } = useTranslation();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const formRef = useRef(null);
  const initialDocument = { vendor_company: null, document_name: null };
  const initialState = {
    company_payment_terms: [
      {
        company: authUserData()?.company ? authUserData()?.company : null,
        days_to_pay: null,
        when_to_pay: null,
        when_to_calculate: null,
        advance: 0,
        payment_security_type: "Open Credit",
        bank_garrentee_value: "",
        bank_guarantee_supply_limit_value: "",
        bank_garrentee_open_date: "",
        bank_garrentee_validity_complation_date: "",
        lc_value: "",
        lc_supply_limit_value: "",
        lc_open_date: "",
        lc_validity_complation_date: "",
        other_payment_security_type: "",
      },
    ],
  };
  const [state, setState] = useState(initialState);

  const [documentState, setDocumentState] = useState(initialDocument);
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiloading] = useState(false);
  const [sizeOne, setSizeOne] = useState(null);
  const [uploadFileOne, setUploadFileOne] = useState("");
  const [fileLinkOne, setFileLinkOne] = useState(null);
  const [fileNameOne, setFileNameOne] = useState(null);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [addedVendorId, setAddedVendorId] = useState(null);
  const [vendorDocumentList, setVendorDocumentList] = useState(null);
  const [refreshGrid, setRefreshGrid] = useState(false);
  const [vendorDocumentId, setVendorDocumentId] = useState(null);
  const [showAdditionalBankFields, setShowAdditionalBankFields] =
    useState(false);
  const [isBankFieldsValid, setIsBankFieldsValid] = useState(false);
  const [isLCFieldsValid, setIsLCFieldsValid] = useState(false);
  const [showAdditionalLCFields, setShowAdditionalLCFields] = useState(false);
  const [formKey, setFormKey] = useState(0);
  let filenameone = "";

  useEffect(() => {
    const getVendorOnboarding = async () => {
      setapiloading(true);
      try {
        const apiResponse = await getRequest(
          `vendor-payment-terms/?vendor=${VendorId}&company=${CompanyId}`
        );
        if (apiResponse.data.success) {
          setState({
            company_payment_terms: apiResponse.data.data.map((payment) => {
              const {
                payment_terms,
                vendor,
                vendor_name,
                company_name,
                remark,
                id,
                ...rest
              } = payment;
              return {
                ...rest,
                company: authUserData()?.company || null,
                advance: payment.advance ?? 0,
              };
            }),
          });

          let days_to_pay = null;
          let when_to_pay = null;
          let when_to_calculate = null;
          let advance = 0;
          let payment_security_type = null;

          if (apiResponse.data.data && apiResponse.data.data.length > 0) {
            days_to_pay = apiResponse.data?.data[0].days_to_pay || null;
            when_to_pay = apiResponse.data?.data[0].when_to_pay || null;
            when_to_calculate =
              apiResponse.data?.data[0].when_to_calculate || null;
            advance = apiResponse.data?.data[0].advance ?? 0;
            payment_security_type =
              apiResponse.data?.data[0].payment_security_type || null;
          }

          state.company_payment_terms.forEach((payment) => {
            formRef.current.setFieldsValue({
              [`days_to_pay`]: days_to_pay,
              [`when_to_pay`]: when_to_pay,
              [`advance`]: advance,
              [`when_to_calculate`]: when_to_calculate,
              [`payment_security_type`]: payment_security_type,
            });
          });

          if (
            apiResponse?.data?.data[0].payment_security_type ===
            "Secure with Bank Garrentee"
          ) {
            setIsLCFieldsValid(false);
            setShowAdditionalBankFields(true);
            setShowAdditionalLCFields(false);
            formRef.current.setFieldsValue({
              lc_validity_complation_date:
                apiResponse?.data?.data[0].lc_validity_complation_date || "",
              lc_open_date: apiResponse?.data?.data[0].lc_open_date || "",
              lc_supply_limit_value:
                apiResponse?.data?.data[0].lc_supply_limit_value || "",
              lc_value: apiResponse?.data?.data[0].lc_value || "",
            });
          } else if (
            apiResponse?.data?.data[0].payment_security_type ===
            "Secure with LC"
          ) {
            setIsBankFieldsValid(false);
            setShowAdditionalBankFields(false);
            setShowAdditionalLCFields(true);
            formRef.current.setFieldsValue({
              bank_garrentee_open_date: "",
              bank_garrentee_validity_complation_date: "",
              bank_garrentee_value: "",
              bank_guarantee_supply_limit_value: "",
            });
          } else {
            setIsBankFieldsValid(true);
            setIsLCFieldsValid(true);
            setShowAdditionalBankFields(false);
            setShowAdditionalLCFields(false);
            formRef.current.setFieldsValue({
              bank_garrentee_open_date: "",
              bank_garrentee_validity_complation_date: "",
              bank_garrentee_value: "",
              bank_guarantee_supply_limit_value: "",
              lc_validity_complation_date:
                apiResponse?.data?.data[0].lc_validity_complation_date || "",
              lc_open_date: apiResponse?.data?.data[0].lc_open_date || "",
              lc_supply_limit_value:
                apiResponse?.data?.data[0].lc_supply_limit_value || "",
              lc_value: apiResponse?.data?.data[0].lc_value || "",
            });
          }
        } else {
          // ErrorNotificationMsg(t("err_getSubscription"));
        }
        setAddedVendorId(
          apiResponse.data.data[0].id ? apiResponse.data.data[0].id : null // or some default value if there are no elements
        );

        if (paymenttermsId) {
          setFormSubmitted(true);
        } else {
          setFormSubmitted(false);
        }

        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };
    if (VendorId !== null && gstVendorId === null) {
      getVendorOnboarding();
    }
    if (gstVendorId === null && VendorId === null) {
      setState(initialState);
      setPaymentTermsId(null);
      formRef.current.setFieldsValue({
        days_to_pay: "",
        when_to_pay: "",
        when_to_calculate: "",
        advance: 0,
        payment_security_type: "",
        bank_garrentee_value: "",
        other_payment_security_type: "",
      });
      setShowAdditionalBankFields(false);
      setShowAdditionalLCFields(false);
    }
    if (gstVendorId !== null && VendorId !== null) {
      setState(initialState);
      setPaymentTermsId(null);
      formRef.current.setFieldsValue({
        days_to_pay: "",
        when_to_pay: "",
        when_to_calculate: "",
        advance: 0,
        payment_security_type: "",
        bank_garrentee_value: "",
        other_payment_security_type: "",
      });
      setShowAdditionalBankFields(false);
      setShowAdditionalLCFields(false);
    }
  }, [VendorId, gstVendorId]);

  useEffect(() => {
    const getVendorDocument = async () => {
      setapiloading(true);
      try {
        let filenameone1;
        const apiResponse = await getRequest(
          "vendor-document/" + vendorDocumentId
        );

        if (apiResponse.data.success) {
          setDocumentState({
            ...apiResponse.data.data,
          });
          try {
            filenameone1 = apiResponse.data.data.document_url.split("/").pop();
            setFileNameOne(filenameone1);
          } catch (e) {
            filenameone1 = "";
            setFileNameOne(null);
          }
          formRef.current.setFieldsValue({
            ...apiResponse.data.data,
          });
        } else {
          ErrorNotificationMsg(t("err_getSubscription"));
        }
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };
    if (vendorDocumentId !== null) {
      getVendorDocument();
    }
  }, [vendorDocumentId, t]);

  const handlePaymntSecurityTypeChange = (name, value) => {
    let updatedPaymentTerms;
    if (value === "Secure with Bank Garrentee") {
      updatedPaymentTerms = [...state.company_payment_terms];
      setIsLCFieldsValid(false);
      updatedPaymentTerms[0] = {
        ...updatedPaymentTerms[0],
        bank_garrentee_open_date: null,
        bank_garrentee_validity_complation_date: null,
        bank_garrentee_value: "",
        bank_guarantee_supply_limit_value: "",
        [name]: value,
      };
      setState({
        ...state,
        company_payment_terms: updatedPaymentTerms,
      });
      formRef.current.setFieldsValue({
        bank_garrentee_open_date: "",
        bank_garrentee_validity_complation_date: "",
        bank_garrentee_value: "",
        bank_guarantee_supply_limit_value: "",
      });
      setShowAdditionalBankFields(true);
      setShowAdditionalLCFields(false);
    } else if (value === "Secure with LC") {
      updatedPaymentTerms = [...state.company_payment_terms];
      setIsBankFieldsValid(false);
      updatedPaymentTerms[0] = {
        ...updatedPaymentTerms[0],
        lc_validity_complation_date: null,
        lc_open_date: null,
        lc_supply_limit_value: "",
        lc_value: "",
        [name]: value,
      };
      setState({
        ...state,
        company_payment_terms: updatedPaymentTerms,
      });
      formRef.current.setFieldsValue({
        [`lc_validity_complation_date`]: "",
        [`lc_open_date`]: "",
        [`lc_supply_limit_value`]: "",
        [`lc_value`]: "",
      });
      setShowAdditionalBankFields(false);
      setShowAdditionalLCFields(true);
    } else {
      updatedPaymentTerms = [...state.company_payment_terms];
      setIsBankFieldsValid(true);
      setIsLCFieldsValid(true);
      updatedPaymentTerms[0] = {
        ...updatedPaymentTerms[0],
        bank_garrentee_open_date: null,
        bank_garrentee_validity_complation_date: null,
        bank_garrentee_value: "",
        bank_guarantee_supply_limit_value: "",
        lc_validity_complation_date: null,
        lc_open_date: null,
        lc_supply_limit_value: "",
        lc_value: "",
        [name]: value,
      };
      setState({
        ...state,
        company_payment_terms: updatedPaymentTerms,
      });
      formRef.current.setFieldsValue({
        [`bank_garrentee_open_date`]: "",
        [`bank_garrentee_validity_complation_date`]: "",
        [`bank_garrentee_value`]: "",
        [`bank_guarantee_supply_limit_value`]: "",
        [`lc_validity_complation_date`]: "",
        [`lc_open_date`]: "",
        [`lc_supply_limit_value`]: "",
        [`lc_value`]: "",
      });
      setShowAdditionalBankFields(false);
      setShowAdditionalLCFields(false);
    }
    setFormKey((prevKey) => prevKey + 1);
  };
  const handleDatepickerChange = (date, dateString, name) => {
    const formattedDateString =
      dateString && dateString !== "Invalid Date" ? dateString : null;

    const updatedPaymentTerms = [...state.company_payment_terms];
    updatedPaymentTerms[0] = {
      ...updatedPaymentTerms[0],
      [name]: formattedDateString,
    };
    setState({
      ...state,
      company_payment_terms: updatedPaymentTerms,
    });
  };

  const handlePaymentChange = (name, value) => {
    const updatedPaymentTerms = [...state.company_payment_terms];
    updatedPaymentTerms[0] = {
      ...updatedPaymentTerms[0],
      [name]: value,
    };

    setState({
      ...state,
      company_payment_terms: updatedPaymentTerms,
    });
  };

  const handleRefreshGrid = () => {
    setRefreshGrid((refreshGrid) => !refreshGrid);
  };
  const handleSubmit = async () => {
    console.log('statefdxsz', state);
    
    const requiredFields = [
      "payment_security_type",
      "advance",
      "when_to_calculate",
      "when_to_pay",
      "days_to_pay",
    ];

    const isInvalidRow = state.company_payment_terms.some((payment) =>
      requiredFields?.filter((i) => i.advance === null).some(
        (field) => payment[field] === null || payment[field] === undefined
      )
    );

    if (isInvalidRow) {
      ErrorNotificationMsg(t("Please Fill All Fields"));
      return;
    }
    const payload = {
      company_payment_terms:
        state.company_payment_terms &&
        state.company_payment_terms.map((payment) => ({
          ...payment,
          company:
            payment.company === null
              ? authUserData()?.company
              : payment.company,
          advance: payment.advance === null ? 0 : payment.advance
        })),
    };
    console.log('payloadcxz', payload);
    

    try {
      setBtnLoading(true);
      let response;

      if (
        paymenttermsId === null &&
        gstVendorId === null &&
        VendorId !== null
      ) {
        response = await patchRequest(
          `vendor-payment-terms/${VendorId}/add-payment-terms/`,
          payload
        );
      }
      if (
        paymenttermsId === null &&
        gstVendorId !== null &&
        VendorId === null
      ) {
        response = await patchRequest(
          `vendor-payment-terms/${gstVendorId}/add-payment-terms/`,
          payload
        );
      }

      if (
        paymenttermsId !== null &&
        VendorId !== null &&
        gstVendorId === null
      ) {
        const url =
          VendorId !== null
            ? `vendor-payment-terms/${VendorId}/`
            : `vendor-payment-terms/${gstVendorId}/`;

        response = await patchRequest(url, payload);
      }

      setFormSubmitted(true);

      if (response.data.success) {
        if (response.data?.data?.company_payment_terms) {
          setPaymentTermsId(response.data.data.company_payment_terms[0].id);
          setAddedVendorId(
            response.data.data.company_payment_terms.length > 0
              ? response.data.data.company_payment_terms[0].id
              : null
          );
        } else {
          setPaymentTermsId(response.data.data[0].id);

          setAddedVendorId(
            response.data.data.length > 0 ? response.data.data[0].id : null
          );
        }
        SuccessNotificationMsg(
          paymenttermsId === null && gstVendorId === null && VendorId !== null
            ? t("payment_terms_added_successfully")
            : t("payment_terms_updated_successfully")
        );
        setBtnLoading(false);
        setShowPaymentPersonReleasedField(true);
      }
    } catch (error) {
      ErrorNotificationMsg();
      setBtnLoading(false);
    }
  };
  const handleVendorSubmit = async () => {
    const payload = {
      vendor_company: addedVendorId,
      document_name: documentState.document_name,
    };

    try {
      let apiResponse;
      let customerHeaders = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const formData = new FormData();

      formData.append("document_url", uploadFileOne);
      formData.append("form_data", JSON.stringify(payload));
      if (vendorDocumentId === null) {
        apiResponse = await postRequest(
          "vendor-document/",
          formData,
          customerHeaders
        );
      } else {
        apiResponse = await patchRequest(
          `vendor-document/${vendorDocumentId}/`,
          formData,
          customerHeaders
        );
      }

      if (apiResponse.data.success === true) {
        setVendorDocumentList(apiResponse.data.data);
        handleRefreshGrid();
        SuccessNotificationMsg(
          vendorDocumentId === null
            ? t("document_added_successfully")
            : t("document_updated_successfully")
        );
        setVendorDocumentId(null);
        setDocumentState({ document_name: null });

        formRef.current.setFieldsValue({
          document_name: "",
        });
        setDocumentState((prevState) => ({
          ...prevState,
          document_url: null,
        }));
        setUploadFileOne("");
        setFileNameOne(null);
        setFileLinkOne(null);
      }
      setBtnLoading(false);
    } catch (error) {
      setBtnLoading(false);
    }
  };

  const updateBankFieldsValidity = (isValid) => {
    setIsBankFieldsValid(isValid);
  };

  const updateLCFieldsValidity = (isValid) => {
    setIsLCFieldsValid(isValid);
  };

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value !== "" ? value : null });
  };

  return (
    <>
      <Spin spinning={apiLoading}>
        <Form
          // onFinish={handleSubmit}
          autoComplete="off"
          // key={formKey}
          ref={formRef}
        >
          <Row gutter={[15]}>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={6}
              className="TextFeild gutter-row"
            >
              <Form.Item
                name="days_to_pay"
                label={t("label_days_to_pay")}
                prefix={<User />}
                rules={[
                  {
                    required: true,
                    message: t("val_days_to_pay"),
                  },
                ]}
              >
                <Select
                  showArrow
                  allowClear
                  showSearch
                  placeholder={t("pl_days_to_pay")}
                  onChange={(value) =>
                    handlePaymentChange("days_to_pay", value)
                  }
                  optionFilterProp="children"
                >
                  <Select.Option value="7 days">7 days</Select.Option>
                  <Select.Option value="15 days">15 days</Select.Option>
                  <Select.Option value="21 days">21 days</Select.Option>
                  <Select.Option value="30 days">30 days</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={6}
              className="TextFeild gutter-row"
            >
              <Form.Item
                name="when_to_pay"
                label={t("label_when_to_pay")}
                prefix={<User />}
                rules={[
                  {
                    required: true,
                    message: t("val_when_to_pay"),
                  },
                ]}
              >
                <Select
                  showArrow
                  allowClear
                  showSearch
                  placeholder={t("pl_when_to_pay")}
                  onChange={(value) =>
                    handlePaymentChange("when_to_pay", value)
                  }
                  optionFilterProp="children"
                >
                  <Select.Option value="Within">Within</Select.Option>
                  <Select.Option value="NET">NET</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={6}
              className="TextFeild gutter-row"
            >
              <Form.Item
                name="when_to_calculate"
                label={t("label_when_to_calculate")}
                prefix={<User />}
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("val_when_to_calculate")}</Trans>,
                  },
                ]}
              >
                <Select
                  showArrow
                  allowClear
                  showSearch
                  placeholder={t("pl_when_to_calculate")}
                  onChange={(value) =>
                    handlePaymentChange("when_to_calculate", value)
                  }
                  optionFilterProp="children"
                >
                  <Select.Option value="From the date of invoice">
                    From the date of invoice
                  </Select.Option>
                  <Select.Option value="From the date of reciept of material at site">
                    From the date of reciept of material at site
                  </Select.Option>
                  <Select.Option value="From the good reciept note(GRN)">
                    From the good reciept note(GRN)
                  </Select.Option>
                  <Select.Option value="Prior to dispach">
                    Prior to dispach
                  </Select.Option>
                  <Select.Option value="Others">Others</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={6}
              className="TextFeild gutter-row"
            >
              <Form.Item
                label={t("label_advance")}
                name="advance"
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("val_advance")}</Trans>,
                  },
                  {
                    pattern: /^(100|[1-9]?[0-9])$/,
                    message: "Enter a number between 0 and 100",
                  },
                ]}
                initialValue={state.advance}
              >
                <Input
                  type="number"
                  placeholder={t("pl_advance")}
                  onKeyPress={(e) => {
                    if (e.key === "." || e.key === "e") {
                      e.preventDefault(); 
                    }
                  }}
                  onChange={(e) =>
                    // handleChange(
                    //   "advance",
                    //   parseInt(e.target.value, 10) || null
                    // )
                    handlePaymentChange(
                      "advance",
                      parseInt(e.target.value, 10) || null
                    )
                  }
                  prefix={<PercentageOutlined />}
                />
              </Form.Item>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={6}
              className="TextFeild gutter-row"
            >
              <Form.Item
                name="payment_security_type"
                label={t("pl_payment_security_type")}
                prefix={<User />}
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("val_payment_security_type")}</Trans>,
                  },
                ]}
              >
                <Select
                  showArrow
                  allowClear
                  showSearch
                  placeholder={t("pl_payment_security_type")}
                  onChange={(value) =>
                    handlePaymntSecurityTypeChange(
                      "payment_security_type",
                      value
                    )
                  }
                  optionFilterProp="children"
                >
                  <Select.Option value="Open Credit">Open Credit</Select.Option>
                  <Select.Option value="Secure with Bank Garrentee">
                    Secure with Bank Guarantee
                  </Select.Option>
                  <Select.Option value="Secure with LC">
                    Secure with LC
                  </Select.Option>
                </Select>
              </Form.Item>
            </Col>
            {showAdditionalBankFields && (
              <Col
                xs={24}
                sm={24}
                md={12}
                lg={18}
                xl={18}
                className=" gutter-row"
              >
                <PaymentBankFields
                  handleSubmit={handleSubmit}
                  formKey={formKey}
                  handlePaymentChange={handlePaymentChange}
                  handleDatepickerChange={handleDatepickerChange}
                  state={state}
                  updateBankFieldsValidity={updateBankFieldsValidity}
                />
              </Col>
            )}
            {showAdditionalLCFields && (
              <Col
                xs={24}
                sm={24}
                md={12}
                lg={18}
                xl={18}
                className=" gutter-row"
              >
                <PaymentLCFields
                  handleSubmit={handleSubmit}
                  formKey={formKey}
                  handlePaymentChange={handlePaymentChange}
                  handleDatepickerChange={handleDatepickerChange}
                  state={state}
                  updateLCFieldsValidity={updateLCFieldsValidity}
                />
              </Col>
            )}
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={6}
              className="TextFeild gutter-row"
            ></Col>
          </Row>
          <div className="subbuttonsrow">
            <ButtonField
              type="primary"
              icon={<SaveOutlined />}
              onClick={handleSubmit}
              label={t("save")}
              loading={btnLoading}
              disabled={!isBankFieldsValid && !isLCFieldsValid}
            />
          </div>
        </Form>
      </Spin>
    </>
  );
};
PaymentVendor.propTypes = {
  VendorId: PropTypes.number,
  paymenttermsId: PropTypes.any,
  setPaymentTermsId: PropTypes.func,
  gstVendorId: PropTypes.number,
  gstValue: PropTypes.number,
  setShowPaymentPersonReleasedField: PropTypes.func,
};
export default PaymentVendor;
